import { useContext } from 'react';
import SearchContext from 'src/contexts/SearchContext/SearchContext';

const useSearch = () => {
  return useContext(SearchContext);
};

export default useSearch;
